import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import JsBarcode from 'jsbarcode';
import api from '../../services/api';
import { LanguageToggle, useLanguage } from '../../context/LanguageContext';

const CardPage = () => {
  const { token } = useParams();
  const { t } = useLanguage();
  const [card, setCard] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get(`/accounts/cards/${token}/`)
      .then((response) => setCard(response.data))
      .catch((err) => setError(err.response?.data?.code === 'revoked' || err.response?.status === 410 ? t('desk.card_revoked') : (err.response?.data?.error || t('card.missing'))));
  }, [token]);

  useEffect(() => {
    if (!card?.barcode_value) return;
    const node = document.getElementById('card-barcode');
    if (node) {
      JsBarcode(node, card.barcode_value, { format: 'CODE128', displayValue: true, height: 48 });
    }
  }, [card]);

  return (
    <div className="auth-page">
      <div className="container">
        <div className="auth-card card" style={{ textAlign: 'center' }}>
          <LanguageToggle />
          <h1>{t('card.title')}</h1>
          {error && <div className="alert alert-error">{error}</div>}
          {card && (
            <>
              <h2>{card.chinese_name}</h2>
              <p>{t('card.number')}{card.member_number}</p>
              <p>{card.membership_expires_on ? `${t('card.expires')}${card.membership_expires_on}` : t('card.noExpiry')}</p>
              <QRCodeSVG value={card.qr_token} size={180} />
              <div><svg id="card-barcode" /></div>
              <p>{t('qr.wallet')}</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardPage;
